import script from "./ChSphere.vue?vue&type=script&setup=true&lang=js"
export * from "./ChSphere.vue?vue&type=script&setup=true&lang=js"

import "./ChSphere.vue?vue&type=style&index=0&id=3f002b6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f002b6c"]])

export default __exports__